import axios from 'axios';
import Invoice from "../../../../Entities/Invoice";
import InvoiceLineItem from "../../../../Entities/InvoiceLineItem";
import LineItemEntry from "../../../../Entities/LineItemEntry";
import Rate from "../../../../Entities/Rate";
import Subscription from "../../../../Entities/Subscription";
import Validation from "../../../../Entities/Validation";
import Entity from "../../../../Entities/Entity";
import { api2Url } from '../../../../Store/api.slice';

import {
    queryGetFacilitySettings,
    queryGetInvoice,
    queryListRates,
    queryListSubscriptions,
} from "../../../../Queries";

import { getFacility } from '../../../../Utils/facility';

import featureFlags from "../../../../featureFlags";

const transactionFields = {
    'transaction': [
        'id',
        'notes',
        'created_at',
        'invoice_id',
        'line_item_entry_id',
        'application_date'
    ]
};

const oldInvoiceQueryFields = [
    'id',
    'readable_id',
    'subscription_id',
    'due_on',
    'balance',
    'parking_period_month',
    'parking_period_year',
    'notes',
    'detail_notes',
    'type',
    {
        'line_items': [
            'id',
            'balance',
            'adjusted_gross_amount',
            'adjusted_gross_amounts',
            {
                'entries': [
                    'id',
                    'line_item_id',
                    'type',
                    'amount',
                    'amount_tax_1',
                    'amount_tax_2',
                    'amount_tax_3',
                    'amount_tax_4',
                    'gross_amount',
                    'created_at',
                    transactionFields,
                    {
                        'line_item_payment': [
                            'reversal_entry_id',
                            {
                                'payment': [
                                    'id',
                                    'type',
                                    'payment_meta',
                                    'amount'
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                'parker': [
                    'id',
                    'first_name',
                    'last_name',
                    'selected_start_date',
                    'selected_end_date'
                ]
            },
            {
                'rate': [
                    'id',
                    'name'
                ]
            },
            {
                'fee': [
                    'type',
                    'price',
                    'tax_1',
                    'tax_2',
                    'tax_3',
                    'tax_4'
                ]
            },
            {
                'validation': [
                    'quantity',
                    'type',
                    'product_name'
                ]
            }
        ]
    },
    {
        'subscription': [
            'subscription_name',
            {
                'payor': [
                    'readable_id',
                    'billing_firstname',
                    'billing_lastname',
                    'info_name'
                ]
            },
            {
                'billing_profile': [
                    'facility_id'
                ]
            }
        ]
    },
    {
        'payments': [
            'id',
            'type',
            'payment_meta',
            'amount'
        ]
    },
    {
        'refunds': [
            'id',
            'payment_id',
            'type',
            'refund_meta',
            'amount',
        ]
    },
    transactionFields,
    'created_at'
];

export const invoiceQueryFields = featureFlags.OVERPAYMENT ? [
    'id',
    'readable_id',
    'subscription_id',
    'due_on',
    'balance',
    'parking_period_month',
    'parking_period_year',
    'notes',
    'detail_notes',
    'type',
    {
        'line_items': [
            'id',
            'balance',
            'adjusted_gross_amount',
            'adjusted_gross_amounts',
            featureFlags.CARRYOVER_RATE ? 'line_item_rate_type' : '',
            {
                'entries': [
                    'id',
                    'line_item_id',
                    'type',
                    'amount',
                    'amount_tax_1',
                    'amount_tax_2',
                    'amount_tax_3',
                    'amount_tax_4',
                    'gross_amount',
                    'created_at',
                    transactionFields,
                    {
                        'line_item_payment': [
                            'reversal_entry_id',
                            {
                                'payment': [
                                    'id',
                                    'type',
                                    'payment_meta',
                                    'amount',
                                    'credit_entry_id',
                                    {
                                        'credit_entry': [
                                            'application_date',
                                            {
                                                'credit': [
                                                    'application_type',
                                                    {
                                                        'credit_entries': [
                                                            'type',
                                                            'application_date',
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                    },
                    {
                        'line_item_reversal': [
                            {
                                'payment': [
                                    'id',
                                    'type',
                                    'payment_meta',
                                    'amount',
                                    'credit_entry_id',
                                    {
                                        'credit_entry': [
                                            'application_date',
                                            {
                                                'credit': [
                                                    'application_type',
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                'parker': [
                    'id',
                    'first_name',
                    'last_name',
                    'selected_start_date',
                    'selected_end_date'
                ]
            },
            {
                'rate': [
                    'id',
                    'name'
                ]
            },
            {
                'fee': [
                    'type',
                    'price',
                    'tax_1',
                    'tax_2',
                    'tax_3',
                    'tax_4',
                    'name',
                ]
            },
            {
                'validation': [
                    'quantity',
                    'type',
                    'product_name'
                ]
            }
        ]
    },
    {
        'payments': [
            'id',
            'type',
            'payment_meta',
            'amount',
            'credit_entry_id',
            {
                'credit_entry': [
                    'application_date',
                    {
                        'credit': [
                            'application_type',
                            {
                                'credit_entries': [
                                    'type',
                                    'application_date',
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                'credit': [
                    'amount',
                    {
                        'credit_entries': [
                            'type',
                            'application_date'
                        ]
                    }
                ]
            }
        ]
    },
    {
        'subscription': [
            featureFlags.SUBSCRIPTION_NAME ? 'subscription_name' : '',
            {
                'payor': [
                    'readable_id',
                    'billing_firstname',
                    'billing_lastname',
                    'info_name'
                ]
            },
            {
                'billing_profile': [
                    'facility_id'
                ]
            },
            {
                'credit': [
                    'balance',
                ]
            },
            featureFlags.ACCOUNT_ID ? 'account_id' : '',
        ]
    },
    {
        'refunds': [
            'id',
            'payment_id',
            'type',
            'refund_meta',
            'amount',
        ]
    },
    transactionFields,
    'created_at'
] : oldInvoiceQueryFields;

const oldSubscriptionsQueryFields = [
    {
        'subscriptions': [
            'id',
            {
                'payor': [
                    'readable_id',
                    'billing_firstname',
                    'billing_lastname',
                    'info_name'
                ]
            },
            {
                'billing_profile': [
                    'name'
                ]
            },
            {
                'parkers': [
                    'id',
                    'first_name',
                    'last_name',
                    'rate_id'
                ]
            }
        ]
    }
];
const subscriptionsQueryFields = featureFlags.OVERPAYMENT ? [
    {
        'subscriptions': [
            'id',
            'account_id',
            'subscription_name',
            'tax_exempt',
            {
                'payor': [
                    'readable_id',
                    'billing_firstname',
                    'billing_lastname',
                    'info_name'
                ]
            },
            {
                'billing_profile': [
                    'name'
                ]
            },
            {
                'parkers': [
                    'id',
                    'first_name',
                    'last_name',
                    'rate_id'
                ]
            },
            {
                'credit': [
                    'balance',
                ]
            },
        ]
    }
] : oldSubscriptionsQueryFields;

const ratesQueryFields = [
    {
        'rates': [
            'id',
            'name',
            {
                'fees': [
                    'id',
                    'type',
                    'price',
                    'tax_1',
                    'tax_2',
                    'tax_3',
                    'tax_4',
                    'display_name'
                ]
            },
            {
                'access_devices': [
                    'id',
                    'type',
                    {
                        'fee': [
                            'id',
                            'type',
                            'price',
                            'tax_1',
                            'tax_2',
                            'tax_3',
                            'tax_4',
                            'display_name'
                        ]
                    }
                ]
            }
        ]
    }
];

const facilitySettingsQueryFields = [
    'validation_products',
    'accounting_method'
];

class InvoicePanelConfig {
    initialState = {
        invoice: null
    };

    fieldConfiguration = {
        invoice: {},
        lineItem: {},
        facilityTimezone: null
    };

    rates = [];
    fees = [];
    subscriptions = [];

    constructor({ newMode, invoiceId, facilityId, newInvoiceType }) {
        this.newMode = newMode;
        this.invoiceId = invoiceId;
        this.facilityId = facilityId;
        this.newInvoiceType = newInvoiceType;
    }

    loadConfig = async () => {
        const initializationTasks = [
            this.fetchInvoiceFieldValues(),
            this.fetchLineItemEntryFieldValues(),
            this.fetchValidationFieldValues(),
            this.fetchFacilitySettings(),
            this.fetchLineItemRateTypes(),
            this.getFacilityTimezone(),
        ];

        if (this.newMode) {
            this.createNewInvoice();
            initializationTasks.push(this.fetchSubscriptions(), this.fetchRates(), this.fetchFees());
        } else {
            initializationTasks.push(this.fetchInvoice());
        }

        await Promise.all(initializationTasks);
        return this;
    }

    fetchLineItemRateTypes = async () => {
        const lineItemRateTypeFields = {
            type: { enumName: 'LineItemRateTypeEnum' }
        };

        const { type } = await Entity.getFieldAllowedValues({}, lineItemRateTypeFields, ['type']);

        this.fieldConfiguration.lineItem = {
            ...this.fieldConfiguration.lineItem,
            line_item_rate_type: type,
        };
    }

    fetchInvoiceFieldValues = async () => {
        const data = await Invoice.getFieldAllowedValues(['parking_period_month', 'type', 'adjustmentType']);

        this.fieldConfiguration.invoice = {
            ...this.fieldConfiguration.invoice,
            ...data,
        };
    }

    fetchLineItemEntryFieldValues = async () => {
        const data = await LineItemEntry.getFieldAllowedValues(['type']);
        this.fieldConfiguration.lineItem = {
            ...this.fieldConfiguration.lineItem,
            ...data,
        };
    }

    fetchValidationFieldValues = async () => {
        const data = await Validation.getFieldAllowedValues(['type']);

        this.fieldConfiguration.lineItem = {
            ...this.fieldConfiguration.lineItem,
            validation: data
        };
    }

    createNewInvoice = () => {
        const invoice = Invoice.createNewInvoice(this.newInvoiceType);

        const months = {
            0: 'Jan', 1: 'Feb', 2: 'Mar', 3: 'Apr', 4: 'May', 5: 'Jun',
            6: 'Jul', 7: 'Aug', 8: 'Sep', 9: 'Oct', 10: 'Nov', 11: 'Dec'
        };
        const currentDate = new Date();
        invoice.fields.parking_period_month.value = months[currentDate.getUTCMonth()];
        invoice.fields.parking_period_year.value = currentDate.getUTCFullYear();

        const parking_period_year = {
            options: [
                { value: (currentDate.getUTCFullYear() - 1), label: (currentDate.getUTCFullYear() - 1) },
                { value: currentDate.getUTCFullYear(), label: currentDate.getUTCFullYear() },
                { value: (currentDate.getUTCFullYear() + 1), label: (currentDate.getUTCFullYear() + 1) },
            ]
        };

        const lineItem = new InvoiceLineItem();
        const lineItemEntry = new LineItemEntry();
        lineItemEntry.fields.type.value = 'CHARGE';
        if (featureFlags.CARRYOVER_RATE && this.newInvoiceType === 'CARRYOVER_INVOICE') {
            lineItem.fields.line_item_rate_type.value = 'MONTHLY';
        }
        lineItem.fields.entries.value.push(lineItemEntry);
        invoice.fields.line_items.value.push(lineItem);

        this.fieldConfiguration.invoice = {
            ...this.fieldConfiguration.invoice,
            parking_period_year
        };

        this.initialState.invoice = invoice;
    }

    fetchInvoice = async () => {
        const response = await queryGetInvoice({ invoice_id: this.invoiceId }, invoiceQueryFields);
        if (response.errors) {
            throw response.errors.map(error => error.message);
        }
        const invoice = Invoice.createFromQueryValues(response.data.getInvoice);
        this.subscriptions.push(invoice.fields.subscription.value);

        const parking_period_year = {
            options: [{
                value: invoice.fields.parking_period_year.value,
                label: invoice.fields.parking_period_year.value
            }]
        };

        const subscription = invoice.fields.subscription.value.fields;

        const subscription_id = {
            options: [{
                value: invoice.fields.subscription_id.value,
                label: subscription.payor.value.fields.readable_id.value.trim()
            }]
        };

        const subscriptionName = subscription.subscription_name.value.trim();

        if (featureFlags.SUBSCRIPTION_NAME) {
            this.fieldConfiguration.invoice.subscriptionName = subscriptionName;
        }
        const accountId = `AC-${subscription.account_id.value}`;

        this.fieldConfiguration.invoice = {
            ...this.fieldConfiguration.invoice,
            parking_period_year,
            subscription_id,
            accountId,
        };

        this.initialState.invoice = invoice;
    }

    fetchSubscriptions = async () => {
        const response = await queryListSubscriptions({ facility_id: this.facilityId }, subscriptionsQueryFields);
        if (response.errors) {
            throw response.errors.map(error => error.message);
        }

        const subscriptions = response.data.listSubscriptions.subscriptions.map(subscription =>
            Subscription.createFromQueryValues(subscription)
        );

        const subscriptionId = {
            options: [
                { value: null, label: '' },
                ...subscriptions.map(subscription => {
                    return {
                        value: subscription.fields.id.value,
                        label: [
                            subscription.fields.subscription_name.value,
                            `(AC-${subscription.fields.account_id.value})`,
                        ].join(' ').trim(),
                    };
                }),
            ]
        };

        this.fieldConfiguration.invoice = {
            ...this.fieldConfiguration.invoice,
            subscription_id: subscriptionId,
        };

        this.subscriptions = subscriptions;
    }

    async fetchRates() {
        const response = await queryListRates({
            filters: [{
                model: 'BILLING_PROFILE',
                field: 'facility_id',
                op: 'EQ',
                value: this.facilityId
            }]
        }, ratesQueryFields);

        if (response.errors) {
            throw response.errors.map(error => error.message);
        }

        const rates = response.data.listRates.rates.map(rate =>
            Rate.createFromQueryValues(rate)
        );

        const rate = {
            options: [
                ...rates.map(rate => {
                    return {
                        value: rate.fields.id.value,
                        label: rate.fields.name.value
                    };
                })
            ]
        };

        this.fieldConfiguration.lineItem = {
            ...this.fieldConfiguration.lineItem,
            rate
        };

        this.rates = rates;
    }
    

    async fetchFees() {
        const { token } = window.parkchirp.auth;
            const headers = {
                "content-type": "application/json",
                "Authorization":`Bearer ${token}`
        };
        const graphqlQuery = {
            "operationName": "getFeesForMonthlyUI",
            "query": `query getFeesForMonthlyUI(
                $facilityId: String! 
              ) {
                getFeesForMonthlyUI(
                      facilityId: $facilityId
                  ) {
                      id
                      feeName
                      calculationType
                      feeAccessDeviceType {
                            accessDeviceTypeId
                      }
                      feeTypeId
                      feeType {
                          name
                      }
                      feesHistory {
                        id
                        price
                        taxCalculation
                        tax1
                        tax2
                        tax3
                        tax4
                        inputType
                        taxTableTax1 {
                            taxTableRates {
                                percentageOfNet
                            }
                        }
                        taxTableTax2 {
                            taxTableRates {
                                percentageOfNet
                            }
                        }
                        taxTableTax3 {
                            taxTableRates {
                                percentageOfNet
                            }
                        }
                        taxTableTax4 {
                            taxTableRates {
                                percentageOfNet
                            }
                        }
                      }
                  }
              }`,
            "variables": {facilityId: this.facilityId}
        };


        const response = await axios({
        url: `${api2Url}/graphql`,
        method: 'post',
        headers: headers,
        data: graphqlQuery
        });
        const feeResponse = response.data.data.getFeesForMonthlyUI;
        feeResponse.map((fee) => {
            const fh = fee?.feesHistory[0];
            if (fee.feeTypeId === 6) {
                fee.feeType.name = 'Late'
            }
            if (fh) {
                if (fh.taxCalculation === 'MANUAL' && fh.inputType === 'Gross') {
                    const netFee1 = fh.tax1 ? fh.price * fh.tax1 : 0;
                    const netFee2 = fh.tax2 ? fh.price * fh.tax2 : 0;
                    const netFee3 = fh.tax3 ? fh.price * fh.tax3 : 0;
                    const netFee4 = fh.tax4 ? fh.price * fh.tax4 : 0;

                    const netPrice = fh.price - (netFee1 + netFee2 + netFee3 + netFee4);

                    fh.price = netPrice
                }

                if (fh.taxCalculation === 'TAX_TABLE') {
                    if (fh.inputType === 'Gross') {
                        const netFee1 = fh.taxTableTax1 ? fh.price * (fh.taxTableTax1.taxTableRates[0].percentageOfNet / 10000000) : 0;
                        const netFee2 = fh.taxTableTax2 ? fh.price * (fh.taxTableTax2.taxTableRates[0].percentageOfNet / 10000000) : 0;
                        const netFee3 = fh.taxTableTax3 ? fh.price * (fh.taxTableTax3.taxTableRates[0].percentageOfNet / 10000000) : 0;
                        const netFee4 = fh.taxTableTax4 ? fh.price * (fh.taxTableTax4.taxTableRates[0].percentageOfNet / 10000000) : 0;

                        const netPrice = fh.price - (netFee1 + netFee2 + netFee3 + netFee4);
                        fh.tax1 = netFee1;
                        fh.tax2 = netFee2;
                        fh.tax3 = netFee3;
                        fh.tax4 = netFee4;
                        fh.price = netPrice
                    } else {
                        fh.tax1 = fh.taxTableTax1 ? Math.round((fh.taxTableTax1.taxTableRates[0].percentageOfNet / 10000000) * fh.price) : 0;
                        fh.tax2 = fh.taxTableTax2 ? Math.round((fh.taxTableTax2.taxTableRates[0].percentageOfNet / 10000000) * fh.price) : 0;
                        fh.tax3 = fh.taxTableTax3 ? Math.round((fh.taxTableTax3.taxTableRates[0].percentageOfNet / 10000000) * fh.price) : 0;
                        fh.tax4 = fh.taxTableTax4 ? Math.round((fh.taxTableTax4.taxTableRates[0].percentageOfNet / 10000000) * fh.price) : 0;
                    }
                }
                return fee;
            }
            return null;
          });
        this.fees = feeResponse;
    }

    async fetchFacilitySettings() {
        const response = await queryGetFacilitySettings({ facility_id: this.facilityId }, facilitySettingsQueryFields);
        if (response.errors) {
            throw response.errors.map(error => error.message);
        }

        const facilitySettings = response.data.getFacilitySettings;
        this.fieldConfiguration.lineItem = {
            ...this.fieldConfiguration.lineItem,
            product_names: facilitySettings ? facilitySettings.validation_products : []
        }
    }

    async getFacilityTimezone() {
        const facility = await getFacility(this.facilityId);
        this.fieldConfiguration.facilityTimezone = facility.fields.timezone.value;
    }
}

export default InvoicePanelConfig;
